import Home from '@/page/home/home';

export default [
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
            title: 'home',
            keepAlive: false
        }
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/home.route.js